import React, { useState, useEffect, useRef } from 'react'
import { Link, useHistory, useParams, useLocation } from 'react-router-dom'
import {
  Layout,
  Button,
  Spin,
  Breadcrumb,
  Row,
  Select,
  Col,
  Input,
  Tabs,
  Typography,
  message,
  Collapse,
  Modal,
  Image
} from 'antd'
import { SendOutlined, CopyOutlined, EditOutlined } from '@ant-design/icons'
import SessionStorage from '../../util/sessionstore'
import '../../css/case.scss'
import { connect } from 'react-redux'
import { getPatient } from '../../store/action/patient.action'
import {
  getMessageCase,
  assignedToMoveAi,
  updateLastViewed,
  addComment,
  editWorkLog,
  fetchHealthCoachList,
  deleteWorkLog,
  updateActionCase,
  isNewActionCase,
  getImageUrl,
} from '../../store/action/actioncases.action'
import util from '../../util/util'
import { constants } from '../../constants'
import moment from 'moment'
import _ from 'lodash'
import '../../css/messages.scss'
import PatientMeasurementTable from '../patient/patient.measurement.table'
import WorkLog from '../actioncase/worklog'
import { PlusCircleFilled, ExclamationCircleOutlined ,PlusOutlined} from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import { fetchUsers } from '../../store/action/user.action'
import { loginAsCustomer } from '../../store/action/profile.action'
import Zoom from './zoom'

const { Content } = Layout
const { TabPane } = Tabs
const { Option } = Select
const { Text } = Typography
const MSGLENGTH = 4000
const _status = [
  {
    value: constants.ACTION_CASE_STATUS.ASSIGNED,
    label: 'Assigned',
  },
  //   {
  //   value: constants.ACTION_CASE_STATUS.UNASSIGNED,
  //   label: 'Unassigned',
  // },
  {
    value: constants.ACTION_CASE_STATUS.RESOLVED,
    label: 'Resolved',
  },
  {
    value: constants.ACTION_CASE_STATUS.UNRESOLVED,
    label: 'Unresolved',
  },
  {
    value: constants.ACTION_CASE_STATUS.NOTANISSUE,
    label: 'Not an Issue',
  },
]

const _priority = [
  {
    value: constants.ACTION_CASE_PRIORITY.ONE,
    label: 'P1',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.TWO,
    label: 'P2',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.THREE,
    label: 'P3',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.FOUR,
    label: 'P4',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.CRITICAL,
    label: 'Critical',
  },
  {
    value: constants.ACTION_CASE_PRIORITY.BLOCKER,
    label: 'Blocker',
  },
]
const MessageView = (props) => {
  const session = new SessionStorage()
  const scrollContainerRef = useRef(null)
  const infoName = useRef(null)
  const [actionCase, setActionCase] = useState(props.editCase)
  const [patient, setPatient] = useState({})
  const [messageInput, setMessage] = useState('')
  const history = useHistory()
  const params = useParams()
  const caseId = params.caseid
  const isadmin =
    props.current_user?.role == constants.ROLE.ADMIN ||
    props.current_user?.role == constants.ROLE.SURGEON
  const companyUser =
    props.current_user?.role == constants.ROLE.COMPANY_HEALTHCOACH ||
    props.current_user?.role == constants.ROLE.COMPANY_ADMIN
  const [loading, setLoading] = useState(true)
  const [workLog, setWorkLog] = useState(null)
  const [caseModal, setCaseModal] = useState(false)
  const [healthCoachList, setHealthCoachList] = useState([])
  const [copied, setCopied] = useState(false)
  const profile = session.getProfile()
  const sumRef = useRef()
  const descRef = useRef()
  const rightNavRef = useRef()
  const rightNavCommentRef = useRef()
  const currentUserCompanyId = profile.company?._id || ''
  const [windowDimension, setWindowDimension] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  })
  const location = useLocation()
  const [iseditingSummary, setIsEditingSummary] = useState(false)
  const [iseditingDesc, setIsEditingDesc] = useState(false)
  const [caseDescriptionTxt, setCaseDescriptionTxt] = useState('')
  const [caseSummary, setCaseSummary] = useState('')
  const [desRemaining, setDesRemaining] = useState(MSGLENGTH)
  const [summRemaining, setSummRemaining] = useState(MSGLENGTH)
  const [commRemaining, setCommRemaing] = useState(MSGLENGTH)
  const [fileList, setFileList] = useState([]);
  const [imageUrl,setImageUrl]=useState([])
  const [imageopen,setImageOpen]=useState(false) 
  useEffect(() => {
    const dimension = getBrowserDimensions()
    console.log('setWindowDimension', dimension)
    setWindowDimension(dimension)
  }, [window.innerHeight, window.innerWidth])

  useEffect(() => {
    // DEBUG: Message view loading (REMOVE AFTER TESTING)
    console.log('[DEBUG-MESSAGE-VIEW] Starting to load message details')
    console.log('[DEBUG-MESSAGE-VIEW] Case ID:', caseId)
    console.log('[DEBUG-MESSAGE-VIEW] Customer ID:', props.customer?._id)
    console.log('[DEBUG-MESSAGE-VIEW] Company ID:', props?.company?._id)
    console.log('[DEBUG-MESSAGE-VIEW] Current user role:', props.current_user?.role)
    
    console.log('[DEBUG-MESSAGE-VIEW] Calling getMessageCase...')
    props.getMessageCase(caseId)
    
    console.log('[DEBUG-MESSAGE-VIEW] Calling updateLastViewed...')
    props.updateLastViewed({ caseId: caseId })
    
    console.log('[DEBUG-MESSAGE-VIEW] Calling isNewActionCase...')
    props.isNewActionCase(
      props.customer?._id,
      props.newUser?.surgeon,
      props?.company?._id
    )
    //  props.loginAsCustomer({})
  }, [])

  useEffect(() => {
    // DEBUG: Loading state tracking (REMOVE AFTER TESTING)
    console.log('[DEBUG-MESSAGE-VIEW] Patient/ActionCase changed')
    console.log('[DEBUG-MESSAGE-VIEW] Patient:', props.patient ? 'loaded' : 'null')
    console.log('[DEBUG-MESSAGE-VIEW] ActionCase:', actionCase ? 'loaded' : 'null')
    console.log('[DEBUG-MESSAGE-VIEW] Current loading state:', loading)
    console.log('[DEBUG-MESSAGE-VIEW] Props isLoading:', props.isLoading)
    console.log('[DEBUG-MESSAGE-VIEW] Props patientLoading:', props.patientLoading)
    
    setPatient(props.patient)
    if (actionCase) {
      console.log('[DEBUG-MESSAGE-VIEW] ActionCase found, setting loading to false')
      setLoading(false)
    } else {
      console.log('[DEBUG-MESSAGE-VIEW] No ActionCase, keeping loading state')
    }
  }, [props.patient, actionCase])
  useEffect(() => {
    setLoading(true)
    setActionCase(props.editCase)

    if (props.editCase?.patientData?._id) {
      if (props.editCase?.title != 'System Technical')
        props.fetchPatient(props.editCase.patientData._id)
    }
    {
      !isadmin &&
        // props.getHealthCoachList({ companyid: currentUserCompanyId });
        props.fetchUsers({
          companyid: props.company?._id,
          pagination: { current: null, pageSize: null },
          searchText: props.searchText,
          sorter: { order: 'ascend', field: 'surgery' },
          active: true,
        })
    }
  }, [props.editCase])

  useEffect(() => {
    if (isadmin) return
    const userList =
      // props.healthCoachList?
      props.users?.map((user) => ({
        id: user._id,
        name: user.firstname + ' ' + user.lastname,
      }))
    console.log('awrd', props.users)
    setHealthCoachList(userList)
  }, [props.users])
  // Auto-scroll to bottom when messages load or change
  useEffect(() => {
    // Use setTimeout to ensure DOM is fully rendered before scrolling
    const scrollToBottom = () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight
      }
    }
    // Scroll immediately and also after a short delay to ensure content is rendered
    scrollToBottom()
    const timeoutId = setTimeout(scrollToBottom, 100)
    return () => clearTimeout(timeoutId)
  }, [actionCase?.comments, actionCase])

  const saveEditedComment = async () => {}

  const editWorkLog = async (worklog) => {
    setWorkLog(worklog)
    showCaseModal()
  }
  const showCaseModal = () => {
    setCaseModal((prev) => !prev)
  }

  const savetimeTracking = async (timeTrackingData, timedata) => {
    try {
      const { caseId, caseDescription, priority, status, summary } = actionCase
      let data = {
        caseId,
        description: caseDescription,
        priority,
        status,
        summary,
        healthCoachId: actionCase.assignedTo || patient?.healthcoach?._id,
        ...timedata,
      }
      const response = await props.updateActionCase(data)
      if (response.status == constants.MESSAGE.SUCCESS) {
        props.getMessageCase(caseId)
        // setActionCase({...actionCase,status:value})
      }
    } catch (error) {
      console.log(error)
      message.error('Failed to updated HealthCoach')
    }
  }

  const returnFormatedDate = (date) => {
    return moment(date).isSame(moment().startOf('day'), 'd')
      ? 'Today, ' + moment(date).format('hh:mm a').toString()
      : moment(date).isSame(moment().subtract(1, 'days').startOf('day'), 'd')
        ? 'Yesterday, ' + moment(date).format('hh:mm a').toString()
        : moment(date).format('ddd, DD MMM YYYY, hh:mm a').toString()
  }

  function convertMinutesToHours(minutes) {
    if (minutes == 0) return ''

    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60

    let result = `${hours} hour${hours > 1 ? 's' : ''}`

    if (remainingMinutes > 0) {
      result += ` ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`
    }

    return result
  }

  async function handleBackClick() {
    if (location.state == 'patient') {
      history.push({ pathname: `/patient/${patient._id}` })
      return
    }
    
    // DEBUG: Back navigation logic (REMOVE AFTER TESTING)
    console.log('[DEBUG-BACK-NAV] Current user role:', props.current_user?.role)
    console.log('[DEBUG-BACK-NAV] Location state:', location.state)
    console.log('[DEBUG-BACK-NAV] Current pathname:', location.pathname)
    console.log('[DEBUG-BACK-NAV] History length:', history.length)
    
    // Try to use browser history to go back to where we came from
    const isCompanyRole = props.current_user?.role == constants.ROLE.COMPANY_ADMIN || 
                         props.current_user?.role == constants.ROLE.COMPANY_HEALTHCOACH
    
    if (isCompanyRole) {
      // DEBUG: Using browser back for company roles (REMOVE AFTER TESTING)
      console.log('[DEBUG-BACK-NAV] Company role detected, using browser back')
      history.goBack()
      return
    }
    
    // Fallback to original logic for other roles
    const isSurgeon = props.current_user?.role == constants.ROLE.SURGEON
    const admin = props.current_user?.role == constants.ROLE.ADMIN
    
    if (admin) history.push({ pathname: '/notification' })
    else if (isSurgeon) history.push({ pathname: '/inbox' })
    else history.push({ pathname: '/cases' })
  }

  const assignToMoveAi = async () => {
    try {
      const response = await props.assignedToMoveAi(caseId)

      if (response && response.status == constants.MESSAGE.SUCCESS)
        history.push({ pathname: '/notification' })
    } catch (error) {
      console.log(error, 'Error in assignToMoveAi')
    }
  }
  const submitAssignToMoveAi = async () => {
    Modal.confirm({
      title: 'Are you sure you want to assign to MoveAI?',
      // content: 'Once the gateway updated, the older devices wont work.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => assignToMoveAi(),
      onCancel: () => {},
    })
  }
  const handleView = async(fileName) =>{
     if(!fileName) return;
      try{
         const res= await props.getImageUrl({fileName,type:constants.AWS_FOLDER_NAME.MESSAGE});
        setImageUrl(res.imageUrl)
        setImageOpen(true)
      }
      catch(err){
        console.log(err,"Error in viewImage")
      }     
  }
   const renderImageUrls=(imageUrl)=>{

      if(_.isEmpty(imageUrl) || !imageUrl.thumbnail )return;
      return(
        <div className= {`coversation-img`}>{
         <img 
          src={imageUrl.thumbnail}
          onClick={()=>handleView(imageUrl.original)} 
          alt={`img`}
        />
        }</div>
      )
    }  
  // Helper to determine if a user is a patient (by checking if userid matches patient id or is the reporter)
  const isPatientMessage = (message) => {
    // IMPORTANT: If the message was sent by the current logged-in user (admin), it's ALWAYS a clinic message
    if (message.userid === props.current_user?._id) return false

    // If the message userid matches the patient id, it's from the patient
    if (message.userid === actionCase?.patientData?._id) return true
    // If the message userid matches patient id as string
    if (message.userid === actionCase?.patientData?._id?.toString()) return true
    // If the message is from the original reporter (the person who created the case - usually the patient)
    if (message.userid === actionCase?.reportedBy) return true

    return false
  }

  // Get sender display name with prefix
  const getSenderDisplayName = (message) => {
    const userName = message.userName || 'NA'
    // Check if this message is from a patient
    if (isPatientMessage(message)) {
      return `Patient - ${userName}`
    }
    // MoveAI Messages are already branded as "MoveAI Health Support" —
    // a 'Clinic -' prefix would be wrong
    if (actionCase?.title == constants.ACTION_CASE_TITLE.MOVEAI_MESSAGE) {
      return userName
    }
    // Otherwise it's from clinic staff
    return `Clinic - ${userName}`
  }

  const renderMessageBubble = (message, isInitialMessage = false) => {
    // For clinic users viewing: Patient messages on LEFT (gray), Clinic messages on RIGHT (blue)
    const isFromPatient = isPatientMessage(message)
    const isClinicMessage = !isFromPatient

    return (
      <>
    {message.priority && <div className='priority-outlined-container'>
      <div className='priority-container'>
        <ExclamationCircleOutlined className='priority-outlined'/>
        <span className='priority-outlined urgent'>Urgent</span>
      </div>
  </div>}
       <div className={`${isClinicMessage ? 'message-div rightdiv' : 'message-div leftdiv'} ${(message.comment=='NA' && message.imageUrl)?'imageUrl-div':''} ${message.priority ? 'priority-msg' : ''}` }>
        <div style={{ display: 'flex' }}>
          <div className='message-div-username'>
            {getSenderDisplayName(message)}
          </div>
          <div className='message-div-date'>
            {returnFormatedDate(message.commented_date)}
          </div>
        </div>
        <pre className='message-body' style={{ textAlign: 'start' }} disabled>
          {isInitialMessage && actionCase?.summary && (
            <pre style={{ fontWeight: 'bold', marginBottom: '8px' }}>{actionCase.summary}</pre>
          )}
          <pre>
            {
          //   (message.comment=='NA' && !_.isEmpty(message.imageUrl))?
          //   <img  onClick ={()=>handleView(message.imageUrl?.original)} style={{height:30}} alt='preview'  src={message.imageUrl?.thumbnail}/>
          // :
          message.comment
        }</pre>
        {renderImageUrls(message.imageUrl)}
        </pre>
      </div>
      </>
    )
  }

//   const renderImageModal = () => (
//   <Image
//     src={imageUrl}
//     style={{ display: 'none' }} 
//     height='50%'
    
//     preview={{
//       visible: imageopen,
//       onVisibleChange: (visible) => setImageOpen(visible),
//       height:'80%',
//       movable:false
//     }}
//   />
// );
const renderImageModal = () => (
      <Zoom
        imageUrl={imageUrl}
        imageopen={imageopen}
        onClose={() => setImageOpen(false)}
      />
);

  const saveEditedWorkLog = async (worklog) => {
    await props.editWorkLog(worklog)
    await props.getMessageCase(caseId)
  }
  const handleSendMessage = async () => {
    try {
      if(messageInput.trim() == '')return;
      const commentObject = await props.addComment({
        caseId,
        comment: messageInput,
      })
      if (commentObject.status) {
        setMessage('')
        setCommRemaing(MSGLENGTH)
        await props.getMessageCase(caseId)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const deleteWorkLog = async (input) => {
    var res = await props.deleteWorkLog(input)
    props.getMessageCase(caseId)
  }
  var showConfirmDeleteBox = (type, input) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this work log?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => deleteWorkLog(input),
    })
  }
  const handleStatusChange = async (value) => {
    try {
      const { caseId, caseDescription, priority, status, summary } = actionCase
      let data = {
        caseId,
        description: caseDescription,
        priority,
        status,
        summary,
        healthCoachId:
          actionCase.assignedTo ||
          patient?.healthcoach?._id ||
          props.editCase?.assignedTo ||
          null,
      }
      if (value == 'Unassigned')
        data = {
          ...data,
          status: value,
          healthCoachId:null,
        }
      else data = { ...data, status: value }
      const response = await props.updateActionCase(data)
      if (response.status == constants.MESSAGE.SUCCESS) {
        props.getMessageCase(caseId)
        // setActionCase({...actionCase,status:value})
      }
    } catch (error) {
      console.log(error)
      message.error('Failed to updated status')
    }
  }
  const handlePriorityChange = async (value) => {
    try {
      const { caseId, caseDescription, status, summary } = actionCase
      let data = {
        caseId,
        description: caseDescription,
        priority: value,
        status,
        summary,
        healthCoachId: actionCase.assignedTo || patient?.healthcoach?._id,
      }
      const response = await props.updateActionCase(data)
      if (response.status == constants.MESSAGE.SUCCESS) {
        props.getMessageCase(caseId)
        // setActionCase({...actionCase,status:value})
      }
    } catch (error) {
      console.log(error)
      message.error('Failed to updated priority')
    }
  }
  const handleHealthCoachChange = async (value) => {
    try {
      const { caseId, caseDescription, priority, status, summary } = actionCase
      let data = {
        caseId,
        description: caseDescription,
        priority,
        status,
        summary,
        healthCoachId: value,
        status: 'Assigned',
      }

      const response = await props.updateActionCase(data)
      if (response.status == constants.MESSAGE.SUCCESS) {
        props.getMessageCase(caseId)
        // setActionCase({...actionCase,status:value})
      }
    } catch (error) {
      console.log(error)
      message.error('Failed to updated HealthCoach')
    }
  }
  const copyToClipboard = (e) => {
    e.stopPropagation()
    navigator.clipboard
      .writeText(actionCase?.patientData?._id)
      .then(() => {
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 2000)
      })
      .catch((err) => {
        message.error('Failed to copy')
      })
  }

  const getBrowserDimensions = () => {
    return {
      width:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      height:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
    }
  }

  const formatDescription=(actionCase)=>{
    if(!actionCase)return;
       return{
        userid:actionCase.reportedBy,
        userName:actionCase.reportedUsername,
        commented_date:actionCase.createdDate,
        comment:actionCase.caseDescription,
        imageUrl:actionCase.imageUrl,
       }
  }
  const getColHeight = () => {
    let rightNavHeight = companyUser
      ? rightNavRef.current?.offsetHeight
      : rightNavCommentRef.current?.offsetHeight + 100 // height + margin for this dive ref

    // console.log('2.getColHeight>>>>>>>.', windowDimension, rightNavRef.current?.offsetHeight)
    // rightNavHeight = rightNavHeight + 50; // consider margin
    // console.log('2.getColHeight>>>>>>>.', windowDimension, rightNavCommentRef)
    // console.log('getColHeight>>>>>', rightNavCommentRef.current?.offsetHeight, window.innerHeight - rightNavHeight, window.innerHeight, rightNavHeight)
    return window.innerHeight - rightNavHeight
  }

  const handleSummaryEdit = () => {
    setIsEditingDesc(false)
    setIsEditingSummary(true)
    setSummRemaining(MSGLENGTH - actionCase.summary?.length)
  }
  const handleDescEdit = () => {
    setIsEditingSummary(false)
    setIsEditingDesc(true)
    setDesRemaining(MSGLENGTH - actionCase.caseDescription?.length)
  }

  const saveCaseDescription = async () => {
    try {
      const { caseId, caseDescription, priority, status, summary } = actionCase
      let data = {
        caseId,
        description:
          caseDescriptionTxt != '' ? caseDescriptionTxt : caseDescription,
        priority,
        status,
        summary: caseSummary != '' ? caseSummary : summary,
        healthCoachId: actionCase.assignedTo || patient?.healthcoach?._id,
      }

      const response = await props.updateActionCase(data)
      if (response.status == constants.MESSAGE.SUCCESS) {
        props.getMessageCase(caseId)
        // setActionCase({...actionCase,status:value})
      }
      setCaseDescriptionTxt('')
      setCaseSummary('')
      setIsEditingDesc(false)
      setIsEditingSummary(false)
    } catch (err) {
      console.log('Error in saveCaseDescription', err)
    }
  }

  const cancelDescEdit = () => {
    setCaseDescriptionTxt('')
    setIsEditingDesc(false)
  }

  const cancelSummaryEdit = () => {
    setCaseSummary('')
    setIsEditingSummary(false)
  }

  const returnRemainingText = (remaining) => {
    return (
      <div className='remaining-text'>{`${MSGLENGTH - remaining} out of ${MSGLENGTH} characters `}</div>
    )
  }

  const renderComments = () => {
    // For clinic users (isadmin), return a full-height container
    if (isadmin) {
      return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Row className='message-section' style={{ height: '100%', margin: 0, flex: 1 }}>
            <Row className='message-row' justify='start' style={{ height: '100%', width: '100%' }}>
              {actionCase && (
                <Col span={24} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  {/* Header */}
                  <Row className='row-title' style={{ padding: '0 20px', flexShrink: 0 }}>
                    <h2>Patient Message:</h2>
                  </Row>

                  {/* Message container - scrollable, oldest at top, newest at bottom */}
                  <Col
                    className='message-container'
                    ref={scrollContainerRef}
                    style={{
                      flex: 1,
                      overflowY: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: 0,
                    }}
                  >
                    {/* Initial message (oldest) with bold subject */}
                    {renderMessageBubble(formatDescription(actionCase), true)}
                    {/* Rest of comments in chronological order (oldest to newest) */}
                    {_.clone(actionCase?.comments || [])
                      .sort((a, b) => new Date(a.commented_date) - new Date(b.commented_date))
                      .map((comment) => renderMessageBubble(comment))}
                  </Col>

                  {/* Footer: Response textarea and buttons - always visible at bottom */}
                  <Col style={{ flexShrink: 0, borderTop: '1px solid #e8e8e8', paddingTop: '12px', backgroundColor: '#fff' }}>
                    <Col className='footer-textarea input-row'>
                      <Col span={24}>
                        <Input.TextArea
                          autoSize={{ minRows: 3, maxRows: 3 }}
                          value={messageInput}
                          onChange={(e) => {
                            if (e.target.value.length <= MSGLENGTH) {
                              setMessage(e.target.value)
                              setCommRemaing(MSGLENGTH - e.target.value.length)
                            }
                          }}
                          placeholder='Type Message Here'
                          className='message-input-text'
                        />
                      </Col>
                    </Col>
                    <Row style={{ paddingLeft: 20 }}>
                      {returnRemainingText(commRemaining)}
                    </Row>
                    {/* Bottom row: Assign to MoveAI (left) and Send button (right) */}
                    <Row justify='space-between' align='middle' style={{ padding: '12px 20px' }}>
                      <Col>
                        <Button
                          className='msg-back-button'
                          onClick={submitAssignToMoveAi}
                        >
                          Assign to MoveAI
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          type='primary'
                          onClick={handleSendMessage}
                          className='send-button'
                          style={{ minWidth: '100px' }}
                        >
                          Send
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Col>
              )}
            </Row>
          </Row>
        </div>
      )
    }

    // For company users (MoveAI admins), use Design 2 layout
    return (
      <>
        {companyUser && (
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Tabs
              defaultActiveKey='1'
              tabBarStyle={{ marginLeft: '20px' }}
              style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}
            >
              <TabPane tab='General Info' key='1'>
                <Row className='message-section' style={{ margin: 0 }}>
                  <Row className='message-row' justify='start' style={{ width: '100%' }}>
                    {actionCase && (
                      <Col span={24}>
                        {/* Header */}
                        <Row className='row-title' style={{ padding: '0 20px' }}>
                          <h2>Patient Message:</h2>
                        </Row>

                        {/* Message container - scrollable, uses calc for height */}
                        <Col
                          className='message-container'
                          ref={scrollContainerRef}
                          style={{
                            height: 'calc(100vh - 430px)',
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          {/* Initial message (oldest) with bold subject - only if has content */}
                          {(actionCase?.caseDescription || actionCase?.summary) &&
                            renderMessageBubble(formatDescription(actionCase), true)}
                          {/* Rest of comments in chronological order (oldest to newest) */}
                          {_.clone(actionCase?.comments || [])
                            .sort((a, b) => new Date(a.commented_date) - new Date(b.commented_date))
                            .map((comment) => renderMessageBubble(comment))}
                        </Col>

                        {/* Footer: Response textarea and buttons - always visible at bottom */}
                        <Col style={{ borderTop: '1px solid #e8e8e8', paddingTop: '12px', backgroundColor: '#fff' }}>
                          <Col className='footer-textarea input-row'>
                            <Col span={24}>
                              <Input.TextArea
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                value={messageInput}
                                onChange={(e) => {
                                  if (e.target.value.length <= MSGLENGTH) {
                                    setMessage(e.target.value)
                                    setCommRemaing(MSGLENGTH - e.target.value.length)
                                  }
                                }}
                                placeholder='Type Message Here'
                                className='message-input-text'
                              />
                            </Col>
                          </Col>
                          <Row style={{ paddingLeft: 20 }}>
                            {returnRemainingText(commRemaining)}
                          </Row>
                          {/* Bottom row: Send button (right) */}
                          <Row justify='end' align='middle' style={{ padding: '12px 20px' }}>
                            <Col>
                              <Button
                                type='primary'
                                onClick={handleSendMessage}
                                className='send-button'
                                style={{ minWidth: '100px' }}
                              >
                                Send
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Col>
                    )}
                  </Row>
                </Row>
              </TabPane>
              {
                <TabPane tab='Work log ' key='2'>
                  <Row className='card'>
                    <Row className='tab-details worklog-list'>
                      {_.isEmpty(actionCase?.workLog) && (
                        <Row className='tab-details worklog'>
                          {'No data available'}
                        </Row>
                      )}
                      {actionCase?.workLog
                        ?.sort(
                          (a, b) =>
                            new Date(b.createdAt) - new Date(a.createdAt)
                        )
                        ?.map((item) => (
                          <Row key={item.createdAt} className='worklog'>
                            <Row className='worklog-row'>
                              <Text
                                strong
                                style={{
                                  minWidth: '10vh',
                                  fontSize: '1rem',
                                }}
                              >
                                {item.userName}
                              </Text>
                              <Text
                                style={{
                                  fontSize: '0.8rem',
                                  paddingTop: '3px',
                                }}
                              >
                                on{' '}
                                {moment(item.createdAt).format(
                                  'MM/DD/YYYY, h:mm a'
                                )}
                              </Text>
                            </Row>

                            <Row className='workdescription-container'>
                              <Row className='timeMin-span'>
                                <Text strong className='total-time-label'>
                                  Total Time:
                                </Text>
                                <Text className='total-time-value'>
                                  {item.timeMin
                                    ? convertMinutesToHours(item.timeMin)
                                    : 0}
                                </Text>
                                {props.current_user._id == item.userId && (
                                  <>
                                    {' '}
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '20px',
                                        alignItems: 'center',
                                        marginRight: '3px',
                                        marginLeft: '3px',
                                        textDecoration: 'underline',
                                        color: 'blue',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Text
                                        style={{
                                          color: 'blue',
                                          paddingLeft: '20px',
                                        }}
                                        onClick={() =>
                                          editWorkLog({
                                            ...item,
                                            wlid: item._id,
                                            caseId: props.editCase.caseId,
                                          })
                                        }
                                      >
                                        Edit
                                      </Text>
                                    </div>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '20px',
                                        marginRight: '3px',
                                        marginLeft: '3px',
                                        alignItems: 'center',
                                        textDecoration: 'underline',
                                        color: 'blue',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Text
                                        style={{
                                          color: 'blue',
                                          paddingLeft: '10px',
                                        }}
                                        onClick={() =>
                                          showConfirmDeleteBox(false, {
                                            wlid: item._id,
                                            caseId: props.editCase.caseId,
                                          })
                                        }
                                      >
                                        Delete
                                      </Text>
                                    </div>
                                  </>
                                )}
                              </Row>
                              <Row className='timeMin-span'>
                                <Text strong className='total-time-label'>
                                  Work Details:{' '}
                                </Text>
                                <Text className='total-time-value'>
                                  {item.workDescription}
                                </Text>
                              </Row>
                            </Row>
                          </Row>
                        ))}
                    </Row>
                  </Row>
                </TabPane>
              }
            </Tabs>
          </div>
        )}
      </>
    )
  }

  var renderDetailsNav = () => {
    return (
      <Col>
        {!_.isEmpty(actionCase) && (
          <Row>
            {companyUser && (
              <Row style={{ height: 50 }}>
                <Select
                  size='large'
                  bordered={false}
                  value={actionCase.status}
                  style={{ width: 160, borderRadius: 5 }}
                  onChange={(value) => {
                    handleStatusChange(value)
                  }}
                  className='message-select'
                >
                  {_status.map((item) => {
                    return <Option value={item.value}> {item.label}</Option>
                  })}
                </Select>
              </Row>
            )}
            {/* <Col> */}
            <Row style={{ width: '100%' }}>
              <Collapse defaultActiveKey={['2']} style={{ width: '100%' }}>
                {companyUser && (
                  <Collapse.Panel
                    header={
                      <Col>
                        <Row className='infoName'>
                          {'Case# ' + actionCase.caseNumber}
                        </Row>
                        <Row> {actionCase.caseTitle}</Row>
                      </Col>
                    }
                    key={2}
                  >
                    <Row className='field message-col'>
                      <Text className='detail-text'>Clinic:</Text>
                      <Col>{actionCase.customerName || 'NA'}</Col>
                    </Row>

                    <Row className='field message-col'>
                      <Text className='detail-text'>Case:</Text>
                      <Col>{actionCase.caseNumber}</Col>
                    </Row>

                    <Row className='field message-col'>
                      <Text className='detail-text'>Type:</Text>
                      <Col>{actionCase.caseTitle}</Col>
                    </Row>
                    <Col className='field message-col'>
                      <Text className='detail-text'>Priority :</Text>
                      <Select
                        showSearch
                        filterOption={(input, option) =>
                          option.children[1]
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={actionCase.priority}
                        style={{ width: 230 }}
                        onChange={(value) => {
                          handlePriorityChange(value)
                        }}
                        // className="message-select"
                      >
                        {_priority.map((item) => {
                          return (
                            <Option value={item.value}> {item.label}</Option>
                          )
                        })}
                      </Select>
                    </Col>
                    {!isadmin && (
                      <Col className='field message-col'>
                        <Text className='detail-text'>Assigned to :</Text>
                        <Select
                          showSearch
                          filterOption={(input, option) =>
                            option.children[1]
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          value={actionCase.assignedTo}
                          style={{ width: 230 }}
                          onChange={(value) => handleHealthCoachChange(value)}
                          placeholder={'Select assignee'}
                        >
                          {healthCoachList
                            ?.sort((a, b) => a.name.localeCompare(b.name))
                            .map((item) => {
                              return (
                                <Option value={item.id}> {item.name}</Option>
                              )
                            })}
                        </Select>
                      </Col>
                    )}

                    <Row className='field message-col'>
                      <Text className='detail-text'>Total Work logged: </Text>
                      <Text>
                        {convertMinutesToHours(actionCase?.totalTimeSpent || 0)}
                      </Text>
                      <Col align='start'>
                        <PlusCircleFilled
                          onClick={showCaseModal}
                          className='pluscirclefilled'
                        />
                      </Col>
                    </Row>
                  </Collapse.Panel>
                )}
                {actionCase?.patientData && (
                  <Collapse.Panel
                    header={
                      <Col>
                        <Row className='infoName'>
                          <Col>
                            <Text ref={infoName}>{'Patient: '}</Text>
                            <Button
                              className='button-link'
                              onClick={() => {
                                console.log('CDER', props.editCase)
                                props.patient?.customer &&
                                  props.loginAsCustomer({
                                    ...props.patient?.customer,
                                  })
                                history.push({
                                  pathname: `/patient/${actionCase.patientData?._id}`,
                                  state: {
                                    back: `/cases/${props.editCase?.caseId}`,
                                  },
                                })
                              }}
                            >
                              {_.upperFirst(actionCase?.patientData?.firstname) +
                                ' ' +
                                _.upperFirst(actionCase.patientData?.lastname)}
                            </Button>
                          </Col>
                          <Col align={'center'} style={{ marginLeft: 5 }}>
                            <CopyOutlined onClick={copyToClipboard} />
                            {copied && (
                              <Text style={{ fontSize: 12, color: 'green' }}>
                                Copied!
                              </Text>
                            )}
                          </Col>
                        </Row>
                        <Row style={{ marginTop: 4, fontSize: 16 }}>
                          <Text style={{ fontWeight: 'bold' }}>Phone:&nbsp;</Text>
                          <Text style={{ fontWeight: 'normal' }}>{actionCase.patientData?.phone || `XXXXX-X${actionCase.patientData?.lastdigitsofphone}`}</Text>
                        </Row>
                      </Col>
                    }
                    key={1}
                  >
                    <Col>
                      <Row className='field message-col'>
                        <Text className='detail-text'>Name:</Text>
                        <Col>
                          {_.upperFirst(actionCase?.patientData?.firstname) +
                            ' ' +
                            _.upperFirst(actionCase.patientData?.lastname)}
                        </Col>
                      </Row>

                      <Row className='field message-col'>
                        <Text className='detail-text'>Phone:</Text>
                        <Col>
                          {actionCase.patientData?.phone || `XXXXX-X${actionCase.patientData?.lastdigitsofphone}`}
                        </Col>
                      </Row>

                      <Row className='field message-col'>
                        <Text className='detail-text'>Age group:</Text>
                        <Col>{actionCase?.patientData?.age}</Col>
                      </Row>

                      <Row className='field message-col'>
                        <Text className='detail-text'>Surgery Date:</Text>
                        <Col>
                          {moment(
                            actionCase?.patientData?.surgery?.date
                          ).format('MM/DD/YYYY')}
                        </Col>
                        <Row justify='end' className='infoTitle'>
                          <Col className='infoTitlered' span={24} align='right'>
                            {moment().diff(
                              moment(actionCase?.patientData?.surgery?.date),
                              'days'
                            ) >= 0
                              ? constants.SURGERYTIME.Post
                              : constants.SURGERYTIME.Pre}

                            {' ' +
                              (Math.abs(
                                moment().diff(
                                  moment(
                                    actionCase?.patientData?.surgery?.date
                                  ),
                                  'days'
                                )
                              ) +
                                1) +
                              ' days'}
                          </Col>
                        </Row>
                      </Row>

                      <Row className='measurement-table'>
                        <Col span={24}>
                          <PatientMeasurementTable
                            data={patient?.deviceSchedule}
                            feed={patient?.feedbackSchedule}
                            companyUser={companyUser}
                            isMessage={true}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Collapse.Panel>
                )}
              </Collapse>
            </Row>
          </Row>
        )}
      </Col>
    )
  }

  return (
    <>
      <Spin spinning={props.isLoading || loading || props.patientLoading}>
        <Layout className='layout'>
          <Row justify='space-between' ref={rightNavCommentRef}>
            <Breadcrumb style={{ margin: '1vh 4vh' }}>
              <Breadcrumb.Item>
                <Link
                  to={isadmin ? '/notification' : '/cases'}
                  className='msg-link'
                >
                  Messages
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{actionCase?.caseNumber}</Breadcrumb.Item>
            </Breadcrumb>
            <Row>
              {/* Assign to MoveAI button moved to bottom for clinic users (isadmin) */}
              <Button className='msg-back-button' onClick={handleBackClick}>
                Back
              </Button>
            </Row>
          </Row>

          <Content className='content'>
            <Row justify='space-around'>

              <Col
                span={17}
                style={{ height: getColHeight(), overflow: 'hidden' }}
              >
                {renderComments()}
              </Col>
              <Col
                span={7}
                className='patientInfoContainer'
                style={{ height: getColHeight(), overflowY: 'auto' }}
              >
                {renderDetailsNav()}
              </Col>
            </Row>
          </Content>
        </Layout>
      </Spin>
      {caseModal && (
        <Modal
          visible={caseModal}
          footer={null}
          onCancel={() => {
            setWorkLog(null)
            showCaseModal()
          }}
        >
          <Row>
            <WorkLog
              savetimeTracking={savetimeTracking}
              editWorkLog={saveEditedWorkLog}
              workLog={workLog}
              actionCase={actionCase}
              showCaseModal={() => {
                setWorkLog(null)
                showCaseModal()
              }}
            />
          </Row>
        </Modal>
      )}
     {renderImageModal()}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
    editCase: state.actioncase.editcase,
    isLoading: state.actioncase.isLoading,
    healthCoachList: state.actioncase.healthCoachList,
    token: util.verifyToken(state.profile.token),
    company: state.profile.company,
    current_user: state.profile.user,
    patientLoading: state.patient.isLoading,
    customer: state.profile.customer,
    searchText: state.user.searchText,
    users: state.user.users,
    newUser: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMessageCase: (params) => dispatch(getMessageCase(params)),
    getImageUrl: (params) => dispatch(getImageUrl(params)),
    assignedToMoveAi: (caseId) => dispatch(assignedToMoveAi(caseId)),
    updateLastViewed: (caseId) => dispatch(updateLastViewed(caseId)),
    fetchPatient: (id) => dispatch(getPatient(id)),
    deleteWorkLog: (params) => dispatch(deleteWorkLog(params)),
    editWorkLog: (params) => dispatch(editWorkLog(params)),
    //    editComment : (params) => dispatch(editComment(params)),
    loginAsCustomer: (params) => dispatch(loginAsCustomer(params)),
    addComment: (data) => dispatch(addComment(data)),
    updateActionCase: (params) => {
      return dispatch(updateActionCase(params))
    },
    getHealthCoachList: (params) => {
      return dispatch(fetchHealthCoachList(params))
    },
    fetchUsers: (params) => dispatch(fetchUsers(params)),
    isNewActionCase: (customer, surgeonId, companyId) =>
      dispatch(isNewActionCase(customer, surgeonId, companyId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageView)
